module.exports = __webpack_public_path__ + "img/item-1.5d48598d.svg";